import { render, staticRenderFns } from "./BrandLogoWide.vue?vue&type=template&id=654f59e4&"
import script from "./BrandLogoWide.vue?vue&type=script&lang=js&"
export * from "./BrandLogoWide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports